import axios, { AxiosResponse } from "axios";
import downloadDocument from "@/helpers/functions/DownloadDocument";
import PeriodStats, { PeriodFileFlags } from '../models/api/association/PeriodStats';
class Service {

    
    public async GetPeriodFileFlags(contributionPeriodId: number): Promise<AxiosResponse<PeriodFileFlags>> {
        return axios.get(`api/BatchExportFile/GetPeriodFileFlags/?contributionPeriodId=${contributionPeriodId}`);
    }

    public async GetPeriodStats(contributionPeriodId: number): Promise<AxiosResponse<PeriodStats>> {
        return axios.get(`api/BatchExportFile/GetPeriodStats/?contributionPeriodId=${contributionPeriodId}`);
    }

    public async AddBatchJob(periodId: number): Promise<AxiosResponse<any>> {
        return axios.get(`api/BatchExportFile/AddBatchJob/?periodId=${periodId}`);
    }

    public async GetBatchJobsByIds(idsString: string): Promise<AxiosResponse<any>> {
        return axios.get(`api/BatchExportFile/GetBatchJobsByIds?idsString=${idsString}`);
    }

    public async GetBatchJobsPaged(data: any): Promise<AxiosResponse<any>> {
        return axios.post('api/BatchExportFile/GetBatchJobsPaged', data);
    }

    public async GetFile(batchId: number): Promise<void> {
        await axios.get(`api/BatchExportFile/GetFile/?batchId=${batchId}`).then(response => {
            console.log(response);
            downloadDocument(response);
        });
        return;
    }

    public async DeleteBatchJob(id: number): Promise<AxiosResponse<any>> {
        return axios.delete(`api/BatchExportFile/${id}`);
    }
}

export const BatchExportFileService: Service = new Service();
